var __jsx = React.createElement;
import React from "react";
var MoreButtonSVG = function MoreButtonSVG() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "MoreButtonSVG",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M14.7075 16.2875L10.8275 12.4075L14.7075 8.5275C15.0975 8.1375 15.0975 7.5075 14.7075 7.1175C14.3175 6.7275 13.6875 6.7275 13.2975 7.1175L8.7075 11.7075C8.3175 12.0975 8.3175 12.7275 8.7075 13.1175L13.2975 17.7075C13.6875 18.0975 14.3175 18.0975 14.7075 17.7075C15.0875 17.3175 15.0975 16.6775 14.7075 16.2875Z",
    fill: "#154F9C"
  })));
};
export default MoreButtonSVG;